import { render, staticRenderFns } from "./AllocationSearch.vue?vue&type=template&id=2768e1d7"
import script from "./AllocationSearch.vue?vue&type=script&lang=js"
export * from "./AllocationSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2768e1d7')) {
      api.createRecord('2768e1d7', component.options)
    } else {
      api.reload('2768e1d7', component.options)
    }
    module.hot.accept("./AllocationSearch.vue?vue&type=template&id=2768e1d7", function () {
      api.rerender('2768e1d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/AllocationSearch.vue"
export default component.exports